import { createContext } from "react";

export interface ITrackerContext {
  // State Values
  day: moment.Moment;
  formData: TrackerForm;
  typeOfTracking: TrackingType;
  isTracking: boolean;
  trackerLoading: boolean;
  startTime: string;
  endTime: string;
  liveTime: number;

  // State Update Methods
  setDay: React.Dispatch<React.SetStateAction<moment.Moment>>;
  setFormData: React.Dispatch<React.SetStateAction<TrackerForm>>;
  setStartTime: React.Dispatch<React.SetStateAction<string>>;
  setEndTime: React.Dispatch<React.SetStateAction<string>>;

  // Functions
  switchTracker: (type: TrackingType) => void;
  createSession: (
    startTimeProps?: string,
    endTimeProps?: string,
    dayProps?: moment.Moment,
  ) => Promise<void>;
  startTracking: (projectId?: string, description?: string) => Promise<void>;
  stopTracking: () => Promise<void>;
  editCurrentSession: (start: string) => Promise<void>;
  showModal: () => void;
  handleClose: () => void;
}
export const TrackerContext = createContext<ITrackerContext>(
  {} as ITrackerContext,
);
export type TrackingType = "Auto" | "Manual" | "Calendar";
export interface TrackerForm {
  projectId: string;
  description?: string;
  day?: string;
}
export const defaultTrackerForm: TrackerForm = {
  projectId: "",
  description: "",
  day: "",
};
export type PreparedSession = {
  start: string;
  projectId: string;
  description?: string;
};

export const TypeOfTrackingLocalStorageKey = "internal-app-type-of-tracking";
